import { setServerTime } from '@tencent/wphk-components-common/utils/server-time';

// 设置系统时间
const win: any = window;
const serverTime = win.__$$_serverTimeMills ? new Date(win.__$$_serverTimeMills) : new Date();
setServerTime(serverTime.getTime());
